/**
 * Which Picture-in-Picture mechanism the browser offers, best first:
 * - "document": Document PiP (desktop Chromium, Firefox 151+) - a floating
 *   window we can render any React UI into (video plus controls).
 * - "video": plain element PiP (Safari, older Firefox and Chromium, mobile) -
 *   one video track only, no custom controls.
 * - "none": nothing usable.
 */
export type PipTier = "document" | "video" | "none";

/** Detects the best available PiP tier. `win` is injectable for tests. */
export function detectPipTier(win: Window = window): PipTier {
  if ("documentPictureInPicture" in win && win.documentPictureInPicture) {
    return "document";
  }
  if (win.document?.pictureInPictureEnabled) return "video";
  // Safari exposes PiP via the WebKit presentation-mode API instead.
  const proto = (win as unknown as { HTMLVideoElement?: { prototype?: unknown } })
    .HTMLVideoElement?.prototype as
    | { webkitSupportsPresentationMode?: unknown }
    | undefined;
  if (typeof proto?.webkitSupportsPresentationMode === "function") return "video";
  return "none";
}
